<div class="data-block data-block--block-labels">
  <div class="data-block__item">
    <div class="data-block__label">Lat/Long:</div>
    <div class="data-block__value">
      <ul class="ul">
        <li>{{airport.location.format('-d', { decimalPlaces: 5, latLonSeparator: ', ' })}}</li>
        <li>{{airport.location.format('FFf', { decimalPlaces: 1, latLonSeparator: ', ' })}}</li>
        <li>{{airport.location.format('Ff', { decimalPlaces: 3, latLonSeparator: ', ' })}}</li>
      </ul>
    </div>
  </div>
  <div class="data-block__item">
    <div class="data-block__label">ARTCC:</div>
    <ng-container *ngIf="airport.artcc && airport.artccName; else generalPlaceholder">
      <div class="data-block__value">{{airport.artccName}} ({{airport.artcc}})</div>
    </ng-container>
  </div>
  <div class="data-block__item">
    <div class="data-block__label">App/Depart Control Facility:</div>
    <ng-container *ngIf="airport.masterAirportTower; else generalPlaceholder">
      <div class="data-block__value">{{airport.masterAirportTower}}</div>
    </ng-container>
  </div>
  <div class="data-block__item">
    <div class="data-block__label">Chart:</div>
    <ng-container *ngIf="airport.chart; else generalPlaceholder">
      <div class="data-block__value">{{airport.chart}}</div>
    </ng-container>
  </div>
  <div class="data-block__item">
    <div class="data-block__label">FSS:</div>
    <ng-container *ngIf="airport.fssName && airport.fssId; else generalPlaceholder">
      <div class="data-block__value">{{airport.fssName}} ({{airport.fssId}})<br/>{{airport.fssPhone}}</div>
    </ng-container>
  </div>
  <div class="data-block__item">
    <div class="data-block__label">Wind Indicator:</div>
    <div class="data-block__value">{{windIndicator}}</div>
  </div>
  <div class="data-block__item">
    <div class="data-block__label">Mag Var:</div>
    <ng-container *ngIf="airport.magVariation; else generalPlaceholder">
      <div class="data-block__value">{{airport.magVariation}} {{airport.magVariationEpochYear ? '(' + airport.magVariationEpochYear + ')' : ''}}</div>
    </ng-container>
  </div>
  <div class="data-block__item">
    <div class="data-block__label">NOTAM Facility:</div>
    <ng-container *ngIf="airport.notamIdentifier; else generalPlaceholder">
      <div class="data-block__value"><a href="https://pilotweb.nas.faa.gov/PilotWeb/" target="_blank">{{airport.notamIdentifier}}</a></div>
    </ng-container>
  </div>
  <div class="data-block__item">
    <div class="data-block__label">Seg Circle:</div>
    <div class="data-block__value">{{segmentedCircle}}</div>
  </div>
  <div class="data-block__item operations__lighting">
    <div class="data-block__label">Beacon:</div>
    <div class="data-block__value">{{beacon}}</div>
    <div class="data-block__label operations__pcl-label">Lighting:
    </div>
    <div class="data-block__value">
      <div class="data-list" *ngIf="editModeSet || airport.pilotControlledLighting.length > 0 || lightingRemarks.length > 0; else lightingPlaceholder">
        <app-data-item *ngIf="editModeSet || airport.pilotControlledLighting.length > 0"
                       [source]="Source.AirportManager" [compact]="true" [flex]="true">
          <div class="operations__pcl-header" *ngIf="!editModeSet">Pilot Activated Lighting:</div>
          <ul class="ul operations__pcl-list" *ngIf="!editModeSet; else editPCLPlaceholder">
            <li *ngFor="let brightness of pilotControlledLighting" class="ul operations__pcl-item">
              <span class="operations__pcl-text">
                {{lightingIntensity(brightness.intensity)}} intensity: {{brightness.clicks}} clicks in
                {{brightness.seconds}} secs
              </span>
            </li>
          </ul>
        </app-data-item>
        <app-data-item *ngFor="let remark of lightingRemarks" [source]="remark.sourceId" [compact]="true">
          {{ remark.text }}
        </app-data-item>
      </div>
    </div>
  </div>
  <div class="data-block__item operations__pattern-alt">
    <div class="data-block__label operations__pattern-alt-label">Pattern Altitude:
    </div>
    <div class="data-block__value">
      <div class="data-list" *ngIf="editModeSet || airport.patternAltitudes.length >= 1 || patternAltRemarks.length > 0; else patternAltDefault">
        <app-data-item [source]="5" [compact]="true" *ngIf="editModeSet || airport.patternAltitudes.length >= 1" [flex]="true">
          <div class="operations__pattern-alt-list-edit">
            <div class="operations__pattern-alt-header" *ngIf="editModeSet">
              <p>Add pattern altitude</p>
              <button id="add_pa_btn" (click)="openEditPatternAltDialog(null)" mat-mini-fab *ngIf="editModeSet">
                <mat-icon aria-label="Add Pattern Altitude">add</mat-icon>
              </button>
            </div>
            <p *ngFor="let patternAlt of patternAltitudes; let i = index">
              <mat-icon (click)="openEditPatternAltDialog(i)" *ngIf="editModeSet" class="edit-icon" mat-tooltip="Edit" aria-label="Edit pattern altitude">edit</mat-icon>
              <mat-icon (click)="deletePatternAlt(i)" *ngIf="editModeSet" class="delete-icon" mat-tooltip="Delete" aria-label="Delete pattern altitude">delete_outline</mat-icon>
              {{ formatAircraftClass(patternAlt.aircraftClass) }} {{ patternAlt.altitude }} MSL
            </p>
          </div>
        </app-data-item>
        <app-data-item *ngFor="let remark of patternAltRemarks"
                       [source]="remark.sourceId" [compact]="true">
          {{ remark.text }}
        </app-data-item>
      </div>
      <ng-container *ngIf="editModeSet && airport.patternAltitudes.length < 1 && patternAltRemarks.length == 0">
        <div>No data provided. Assume 1000 AGL.</div>
      </ng-container>
    </div>
  </div>
  <div class="data-block__item">
    <div class="data-block__label">Special Operations:</div>
    <div class="data-block__value">
      <div class="data-list">
        <app-data-item *ngIf="airportSpecialOps && airportSpecialOps.length > 0" [source]="1" [compact]="true">
          {{airportSpecialOps}}
        </app-data-item>
        <app-data-item [source]="5" [compact]="true" *ngIf="editModeSet || airportSpecialOpsAirportManager.length > 0">
          <mat-icon
            (click)="openEditTagsDialog(['Operations::'], ['Operations::Helicopter Ops','Operations::Ultralight Ops','Operations::Glider Ops','Operations::Commercial Ops'], 'Special Operations')"
            *ngIf="editModeSet" class="edit-icon" mat-tooltip="Edit" aria-label="Edit special operations">edit</mat-icon>
          {{airportSpecialOpsAirportManager}}
          <ng-container *ngIf="editModeSet && airportSpecialOpsAirportManager.length < 1">
            None Reported
          </ng-container>
        </app-data-item>
      </div>
    </div>
  </div>
</div>
<ng-template #patternAltDefault>
  <div>No data provided. Assume 1000 AGL.</div>
</ng-template>
<ng-template #lightingPlaceholder>
  <div>No lighting reported.</div>
</ng-template>
<ng-template #generalPlaceholder>
  <div class="data-block__value">Unknown</div>
</ng-template>
<ng-template #editPCLPlaceholder>
  <div class="operations__pcl-list-edit">
    <div class="operations__pcl-header">
      <p>Pilot Activated Lighting:</p>
      <button id="add_pcl_btn" (click)="openEditPCLDialog(null)" mat-mini-fab *ngIf="editModeSet">
        <mat-icon aria-label="Add Pattern Altitude">add</mat-icon>
      </button>
    </div>
    <p *ngFor="let brightness of pilotControlledLighting; let i = index" class="operations__pcl-item">
        <mat-icon (click)="openEditPCLDialog(i)" class="edit-icon" mat-tooltip="Edit" aria-label="Edit pilot controlled lighting">edit</mat-icon>
        <mat-icon (click)="deletePCL(i)" class="delete-icon" mat-tooltip="Delete" aria-label="Delete pilot controlled lighting">delete_outline</mat-icon>
        <span class="operations__pcl-text">
                  {{lightingIntensity(brightness.intensity)}} intensity: {{brightness.clicks}} clicks in
          {{brightness.seconds}} secs
                </span>
    </p>
  </div>
</ng-template>
